import { create } from 'zustand';

import { DailyAppointment } from '@/models/appointment/Appointment.ts';

import { updateRoomId } from '@/utils/appointmentUtils.ts';

const initial_state = {
    appointment: undefined,
    is_importance_opened: false,
};

export const usePatientModalStore = create<{
    appointment: DailyAppointment | undefined;
    is_importance_opened: boolean;
    updateRoom: (room_id: string) => void;
    reset: () => void;
}>((set) => ({
    ...initial_state,
    updateRoom: (room_id: string): void =>
        set((state) => {
            if (!state.appointment) return { appointment: undefined };

            const updated_appointment = updateRoomId(state.appointment, room_id);

            return { appointment: updated_appointment };
        }),
    reset: (): void => set({ ...initial_state }),
}));
